import { find, findAll } from "utils/dom"
import { formatMilliseconds, formatVotingDate } from "../utils/formats"
import "toastify-js/src/toastify.css"

export default function () {
	const Indicacao = find("[js-page='indicacao']")
	if (!Indicacao) return

	console.log('indicaçao fase 1 22/07')
	let currentIndicationStep = 1
	let indicatedQuantity = 0
	let votingDateInterval

	function alertRequiredFields(fields, txt, verify = true) {
	fields.map(input => {
		let targetElement = input;

		// Caso seja um SELECT oculto com nice-select
		if (input.tagName === 'SELECT' && input.closest('.custom-select2')) {
			const customSelect = input.closest('.custom-select2');
			const niceSelect = customSelect.querySelector('.nice-select');

			// Remove mensagem anterior, se houver
			const existingMessage = customSelect.querySelector('p.text-paragraph-4');
			if (existingMessage) existingMessage.remove();

			// Insere após o nice-select visível
			niceSelect.insertAdjacentHTML('afterend', `
				<p class="text-paragraph-4" style="color: rgb(220, 38, 38)">
					${txt}
				</p>
			`);
			return;
		}

		// Para campos normais (input, checkbox, etc.)
		const inputParent = input?.parentNode;
		const existingMessage = inputParent?.parentNode?.querySelector('p.text-paragraph-4');
		if (existingMessage) existingMessage.remove();

		if ((verify && !input.checked) && input.type === "checkbox") {
			inputParent.insertAdjacentHTML('afterend', `
				<p class="text-paragraph-4" style="color: rgb(220, 38, 38)">
					${txt}
				</p>
			`);
		} else if ((verify && !input.value) || !verify) {
			inputParent.insertAdjacentHTML('afterend', `
				<p class="text-paragraph-4" style="color: rgb(220, 38, 38)">
					${txt}
				</p>
			`);
		}
	});
}





	function handleChangeSelect(ev) {
		const select = ev.target
		const selectValue = select.value
		const inputField = select.closest('[js-field]').querySelector('.Input')

		if (selectValue === 'others') {
			inputField.querySelector('input').value = ''
			inputField.classList.remove('hidden')
		} else {
			inputField.classList.add('hidden')
			inputField.querySelector('input').value = selectValue
		}
	}

	function verifyFieldsOnSubmit() {
  
		const formElement = find('form')
		const inputFields = findAll('[data-field-required="true"]')
		const inputValues = inputFields.map(v => v.value)
		let hasEmptyInput = true;


		inputFields.some((input) => {
			if (input.type === 'checkbox' || input.type === 'radio') {
				return !input.checked;
			}
			return !input.value;
		});



		inputFields
			.filter(input => input.name.startsWith("valor-indicado"))
			.map(input => {
				const count = inputValues.filter(i => i === input.value && input.value || '').length

				if (count > 1) {
					alertRequiredFields([input], 'Indicado repetido', false)
				}
			})

		inputFields.filter((input) => {
			if (input.type == 'checkbox') {
				return input;
			}
		}).map((input) => {
			const is_checked = (input.checked ? true : false)
			if (is_checked === false) {
				alertRequiredFields([input], 'Campo obrigatório')
				console.log(input)
			}
		})

		if (hasEmptyInput && Indicacao.id === 'indicacao' ) {
			alertRequiredFields(inputFields, 'Campo obrigatório')

		}
		else if (Indicacao.id === 'indicacao-superjuri-BK') {

				const selectFields = findAll('[js-select]')
				const inputJogo = findAll('.custom-input input')


			const repeatedFields = inputFields
				.filter(input => input.name.startsWith("valor-indicado"))
				.map(input => {
					const count = inputValues.filter(i => i === input.value && input.value || '').length

					if (count > 1)
						alertRequiredFields([input], 'Indicado repetido', false)

					return count
				})

			!repeatedFields.some(i => i > 1) && formElement.submit()
		} 

	else if (Indicacao.id === 'indicacao-superjuri') {
	const formElement = find('form');
	const selectFields = findAll('[js-select]');
	let hasAtLeastOneSelect = false;
	let hasRepeatedSelect = false;
	let missingJogoFields = false;
	let missingCustomInput = false; // flag nova para input custom vazio

	const selectedValues = [];

	selectFields.forEach((select) => {
		let value = select.value.trim();

		// Se o valor é 'others', pega o valor do input custom
		if (value === 'others') {
			const fieldBlock = select.closest('[js-field]');
			if (fieldBlock) {
				const customInput = fieldBlock.querySelector('input[name^="valor-indicado"]');

				if (customInput) {
					value = customInput.value.trim();

					// Se o input custom estiver vazio, alerta e bloqueia envio
					if (!value) {
						alertRequiredFields([customInput], 'Preencha o campo customizado');
						missingCustomInput = true;
					}
				} else {
					// Se não encontrou o input custom, também bloqueia (por segurança)
					alertRequiredFields([select], 'Preencha o campo customizado');
					missingCustomInput = true;
				}
			}
		}

		if (value) {
			hasAtLeastOneSelect = true;

			// Verifica se é repetido
			const normalizedValue = value.toLowerCase().trim();
			const normalizedSelectedValues = selectedValues.map(v => v.toLowerCase().trim());

			if (normalizedSelectedValues.includes(normalizedValue)) {
				let alertField = select;
				if (value !== select.value.trim()) {
					const fieldBlock = select.closest('[js-field]');
					alertField = fieldBlock.nextElementSibling?.querySelector('input.custom-input-name') || select;
				}
				alertRequiredFields([alertField], 'Indicado já selecionado');
				hasRepeatedSelect = true;
			} else {
				selectedValues.push(value);
			}

			// Tenta encontrar o campo de jogo relacionado
			let jogoInput = null;
			const fieldBlock = select.closest('[js-field]');
			if (fieldBlock) {
				jogoInput = fieldBlock
					.nextElementSibling
					?.querySelector('input[name^="valor-jogo"]');
			}

			if (jogoInput && !jogoInput.value.trim()) {
				alertRequiredFields([jogoInput], 'Preencha o campo "Jogo do indicado"');
				missingJogoFields = true;
			}
		}
	});

	if (!hasAtLeastOneSelect) {
		alertRequiredFields(selectFields, 'Selecione pelo menos um indicado');
	}

	// Bloqueia o envio se tem algum problema: repetido, jogo vazio, ou custom vazio
	if (!hasRepeatedSelect && !missingJogoFields && !missingCustomInput && hasAtLeastOneSelect) {
		formElement.submit();
	}
}
		
		
		
		else if (Indicacao.id == 'indicacao-publica') {
			const repeatedFields = inputFields
				.filter(input => input.name.startsWith("valor-indicado"))
				.map(input => {
					const count = inputValues.filter(i => i === input.value && input.value || '').length

					if (count > 1)
						alertRequiredFields([input], 'Indicado repetido', false)

					return count
				})

			!repeatedFields.some(i => i > 1) && formElement.submit()
		}
	}

	function verifyGameFields() {
		const gameInputs = findAll('[name^="valor-jogo"]')

		return gameInputs.map(input => {
			const categoryContent = input.closest('[data-category-content]')
			const indicated = categoryContent.querySelector('[name^="valor-indicado"]').value
			const inputParent = categoryContent.querySelector('[js-select]')

			if (inputParent != 'others') {
				return false
			}
			if (indicated && !input.value) {
				alertRequiredFields([input], 'Campo obrigatório')
				return true

			} else return false
		})
	}

	function updateIndicationSteps() {

		const indicationStepMarks = findAll("[data-step-mark]")
		const indicationSteps = findAll("[data-step-content]")

		indicationSteps?.map(step => step.classList.add('hidden'))
		indicationSteps.find((step => +step.dataset.stepContent === currentIndicationStep))
			?.classList.remove('hidden')

		indicationStepMarks?.map(el => {
			const step = +el.dataset.stepMark

			if (step <= currentIndicationStep) {
				el.style.background = 'rgb(239, 187, 110)'
				el.style.color = '#000'
			}
		})
	}

	function handleChangeIndicationSteps() {
		const nextStepAction = find('[data-next-step]')

  
		nextStepAction.addEventListener('click', () => {
      // debugger
			

			const hasMandatoryField = verifyGameFields().some(v => v)
			const emptyField = findAll('[name^="valor-indicado"]').filter(f => !f.value)
			const stickSimple = find('[data-stick-simple]')
			const stickComplete = find('[data-stick-complete]')

			if (indicatedQuantity === 0) {
				//		const emptyField = findAll('[name^="valor-indicado"]').filter(f => !f.value)
				alertRequiredFields(emptyField, 'Campo obrigatório')

				return
			}

			// if (!hasMandatoryField && (emptyField.length === 0)) {
			if (!hasMandatoryField && emptyField.length < findAll('[name^="valor-indicado"]').length) {

				currentIndicationStep++
				updateIndicationSteps()

				if(stickSimple){
					stickSimple.classList.add('hidden')
				}
				if(stickComplete){
					stickComplete.classList.remove('hidden')
				}

				find('#anchor').scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				})
			}
		})
	}

	function handleFilterCategoryRUIMOLD() {
		numbersHeader()
		numbersIndicated()

		const categoryButtons = findAll('[data-category-button]')
		const categoriesContent = findAll('[data-category-content]')
		const buttons = categoryButtons.map(header => header.querySelector('.frame button'))
 
		// buttons.forEach(button => {
		// 	button.querySelector('span').innerText.toLowerCase() === 'popular'
		// 		? button.classList.add('ativo')
		// 		: ''

		// 	button.addEventListener('click', () => {
		// 		buttons.map(btn => btn.classList.remove('ativo'))
		// 		button.classList.add('ativo')
		// 	})
		// })

		// categoryButtons.forEach(btn => {
		// 	btn.addEventListener('click', () => {
		// 		btn.classList.add('ativo')

		// 		categoriesContent.forEach(cat => {
		// 			if (btn.dataset.categoryButton === cat.dataset.categoryContent) {
		// 				cat.classList.add('block')
		// 				cat.classList.remove('hidden')
		// 			}
		// 			else if (btn.dataset.categoryButton === '2') {
		// 				cat.classList.remove('hidden')
		// 			}
		// 			else {
		// 				cat.classList.add('hidden')
		// 			}
		// 		})

		// 		numbersHeader()
		// 		numbersIndicated()
		// 	})
		// })
	}

function handleFilterCategory() {
	numbersHeader()
	numbersIndicated()

	const categoryButtons = findAll('[data-category-button]')
	const categoriesContent = findAll('[data-category-content]')
	const activeFilters = new Set()

	categoryButtons.forEach(btn => {
		const category = btn.dataset.categoryButton.toLowerCase().trim()
		const button = btn.querySelector('button')

		button.addEventListener('click', e => {
			e.preventDefault()

			const isTodas = category === 'todas'

			if (isTodas) {
				// Resetar tudo se clicar em "Todas"
				activeFilters.clear()
				categoryButtons.forEach(b => b.classList.remove('ativo'))
				btn.classList.add('ativo')

				categoriesContent.forEach(cat => {
					cat.classList.remove('hidden')
					cat.classList.add('block')
				})
			} else {
				// Desmarcar "Todas"
				const todasBtn = categoryButtons.find(b => b.dataset.categoryButton.toLowerCase().trim() === 'todas')
				todasBtn?.classList.remove('ativo')

				// Alternar estado do botão clicado
				if (btn.classList.contains('ativo')) {
					btn.classList.remove('ativo')
					activeFilters.delete(category)
				} else {
					btn.classList.add('ativo')
					activeFilters.add(category)
				}

				// Nenhum filtro? Volta para "Todas"
				if (activeFilters.size === 0) {
					todasBtn?.classList.add('ativo')
					categoriesContent.forEach(cat => {
						cat.classList.remove('hidden')
						cat.classList.add('block')
					})
				} else {
					// Mostrar somente categorias ativas
					categoriesContent.forEach(cat => {
						const catCategory = cat.dataset.categoryContent.toLowerCase().trim()
						if (activeFilters.has(catCategory)) {
							cat.classList.remove('hidden')
							cat.classList.add('block')
						} else {
							cat.classList.add('hidden')
							cat.classList.remove('block')
						}
					})
				}
			}

			numbersHeader()
			numbersIndicated()
		})
	})
}



	function numbersHeader() {
		// debugger
		// const allCategorias = findAll('[data-category-content]')
		const allCategorias = findAll('.frame.btn-top')
		const visibleCategories = allCategorias.filter(cat => cat.classList.contains('ativo'))

		const qtdCategorias = document.querySelector('[data-qtd-itens-categoria]')
		const qtdCategoriaTotal = document.querySelector('[data-total-categoria]')

		if (!qtdCategorias && !qtdCategoriaTotal) return

			const isTodasAtiva = document.getElementById('todas')?.classList.contains('ativo');
			if (isTodasAtiva) {
					// Se "todas" está ativa, mostrar o total (sem contar "todas" ela mesma)
					qtdCategorias.innerText = allCategorias.length - 1;
				} else {
					// Caso contrário, mostra apenas as que estão com "ativo"
					qtdCategorias.innerText = visibleCategories.length;
				}

		
		qtdCategoriaTotal.innerText = allCategorias.length - 1
	}

	function numbersIndicated() {
		const visibleIndicatedContainer = findAll('[data-category-content]:not(.hidden)')
		
		setTimeout(() => {
			const allIndicated = visibleIndicatedContainer.map(container =>
				container.querySelector('[name^="valor-indicado"]').value
			).filter(value => value)

			const qtdTotalIndicated = find('[data-total-indicated]')
			const qtdItensIndicated = find('[data-qtd-itens-indicated]')

			indicatedQuantity = allIndicated.length

			qtdItensIndicated.innerText = indicatedQuantity
			qtdTotalIndicated.innerText = visibleIndicatedContainer.length
		}, 100)
	}

	// Voto concluído
	function attCountdown(votingDate, element, container) {
		const now = new Date()
		const differenceTime = votingDate - now

		if (differenceTime <= 0) {
			clearInterval(votingDateInterval)
			container?.remove()

		} else {
			element.textContent = formatMilliseconds(differenceTime)
		}
	}

	function verifyVotingDate() {
		const countdownContainer = find("[data-date-released]")
		const dateValue = countdownContainer.dataset.dateReleased

		if (!dateValue || dateValue === "None") {
			countdownContainer.remove()
		} else {
			const formatedDate = formatVotingDate(dateValue)
			const countdownElement = countdownContainer.querySelector('span')

			votingDateInterval = setInterval(() => attCountdown(formatedDate, countdownElement, countdownContainer), 1000);
		}
	}


	// =================
	document.addEventListener('DOMContentLoaded', () => {
		const selectField = findAll('[js-field] select')
		const submitButton = find('[data-submit-form]')
		const niceSelectDropdown = findAll('.nice-select .nice-select-dropdown');


		if (Indicacao.id === 'indicacao-publica') {
			handleChangeIndicationSteps()
			updateIndicationSteps()
			handleFilterCategory()

			findAll('[name^="valor-indicado"]')?.map(input =>
				input.addEventListener('input', numbersIndicated)
			)

			findAll('[js-select]')?.map(input =>
				input.addEventListener('change', numbersIndicated)
			)

			findAll('[data-cep-mask]')?.map(input => IMask(input, {
				mask: '00000-000'
			}))
		}

		if (Indicacao.id === 'indicacao-concluida') {
			currentIndicationStep = 3
			updateIndicationSteps()
			verifyVotingDate()
		}

		niceSelectDropdown?.forEach((niceSelect) => {
			const optionOthers = niceSelect.querySelector(`.list [data-value="others"]`);
			if (!optionOthers) return;

			const fieldJogo = niceSelect.closest('[js-field]').nextElementSibling;



			const observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					if (mutation.target.classList.contains('selected')) {
						fieldJogo.classList.add('active');
					}
					else {
						fieldJogo.classList.remove('active');
					}
				});
			});

			observer.observe(optionOthers, { attributes: true, childList: true, characterData: true });

			//console.log(optionOthers) kd
		})

		selectField?.forEach(select => select.addEventListener('change', handleChangeSelect))
		submitButton?.addEventListener('click', (e) =>{
			e.preventDefault()
			verifyFieldsOnSubmit()
		})
	})


}